// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1YUOX","header":"PatientQuestionnaire_header__2o-PC","info":"PatientQuestionnaire_info__3UELY"};